<template>
  <div class="main-page map-list">
    <Menus title="机构查询" :home="true" />
    <div class="container-flex">
      <ul>
        <li v-for="(item,index) in mapslist" :key="'key-map-list-'+index">
          <router-link :to="item.url">
            <div class="icon" :style="'background:'+item.color">
              <i :class="'iconfont ' +item.icon "></i>
            </div>
            <div class="title">
              {{item.title}}
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { mapslist } from '../../datas/js/config.js'
import { MAP_ORGAN } from '../../datas/constants/statistics.js'
export default {
  data () {
    return {
      mapslist,
    }
  },
  async mounted () {
    this.$root.getStatistics(`${MAP_ORGAN}`)
  },
  components: {
    Menus
  }
}
</script>
<style lang="stylus">
.map-list
  ul
    width 13.36rem
    margin 1.2rem auto 0
    list-style none
    padding 0
    display flex
    flex-wrap wrap
    li
      width 3rem
      margin 0 0.17rem 0.4rem 0.17rem
      a
        color #fff
        display flex
        width 100%
        height 100%
        flex-direction column
        justify-content center
        align-items center
        height 3rem
        background rgba(255, 255, 255, 0.2)
        border-radius 0.1rem
        text-align center
        font-size 0.32rem
        &:active
          background-color rgba(255, 255, 255, 0.3)
          border solid 1px rgba(255, 255, 255, 0.3)
        .icon
          margin 0 auto 0.2rem auto
          width 1.29rem
          height 1.29rem
          border-radius 50%
          text-align center
          line-height 1.29rem
          .iconfont
            font-size 0.5rem
@media screen and (orientation portrait)
  .map-list
    ul
      width 100%
      li
        width 50%
</style>
